import React from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import { push } from "Helpers/History";

export default function HomePageBtn({
  icon,
  title,
  description,
  btnText,
  route,
}) {
  return (
    <div className="defBtn">
      <div className="logo">{icon}</div>
      <div className="info">
        <strong>{title}</strong>
        <p>{description}</p>
      </div>
      <MuiButton
        className="w-100"
        color="primary"
        onClick={() => push(route)}
        title={btnText}
      />
    </div>
  );
}
